    <div class="container-fluid">
        <div class="row mt-4">
            <div class="col">
                <h5 class="blue"> 
                    <i class="fas fa-pencil-alt">   </i>&nbsp;Editar familia
                </h5>
            </div>
        </div>
        <hr>
        <form #formNuevaFamilia="ngForm" (ngSubmit)="formSubmit(formNuevaFamilia)" novalidate="">
            <div class="container-fuid" style="height: 240px; overflow-y: auto; padding-right: 20px; overflow-x: hidden;">
                <div class="row">
                    <div class="col col-12">
                        <div class="form-group">
                            <label class="form-label">Descripción:</label>
                            <input type="text" autocomplete="off" class="form-control form-control-sm custom-input" placeholder="Descripción" name="txtDescripcion" #txtDescripcion="ngModel" [(ngModel)]='familiaRQ.descripcion' maxlength="25" pattern="^[a-zA-Z0-9À-ÿñÑ\s]{2,25}$" required>
                        </div>

                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col col-12">
                        <label class="form-label">Valor:</label>
                        <input type="text" autocomplete="off" class="form-control form-control-sm custom-input" placeholder="Valor" name="txtValor" #txtValor="ngModel" [(ngModel)]='familiaRQ.valor' maxlength="25" pattern="^[a-zA-Z0-9À-ÿñÑ\s]{2,25}$" required>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col col-2">
                        <label class="form-label">Activo:</label>
                    </div>
                    <div class="col col-10">
                        <p-checkbox name="cbEstatus" #cbEstatus="ngModel" [(ngModel)]="familiaRQ.activo" [binary]="true" inputId="cbActivo"></p-checkbox>
                    </div>
                </div>
                
            </div>

            <div class="row mt-4">
                <div class="col text-end">
                    <button type="button" (click)="onClose()" class="btn btn-sm rounded-button btn-secondary">
                        <i class="fa fa-arrow-left"></i>
                        Regresar
                    </button>
                    <button type="submit" [disabled]="!formNuevaFamilia.form.valid" class="side-space btn btn-sm rounded-button btn-success">
                        Aceptar
                        <i class="fa fa-check"></i>
                    </button>
                </div>
            </div>
        </form>

    </div>